import React from 'react';
import clsx from 'clsx';

import Icon from 'components/Icon';
import Button from 'components/ui/Button';

import css from './SlideButton.module.scss';

interface Props {
    position: 'left' | 'right';
    offsetTop?: string;
    onClickEvent: React.MouseEventHandler<HTMLButtonElement>;
}

const SlideButton: React.FC<Props> = ({ position = 'left', onClickEvent, offsetTop }) => {
    return (
        <Button
            onClick={onClickEvent}
            color="white"
            style={{ top: offsetTop }}
            className={clsx(css.button, position === 'left' ? css.leftButton : css.rightButton)}
        >
            <Icon name={position === 'left' ? 'arrow-left-thick' : 'arrow-right-thick'} width={20} color="gray2" />
        </Button>
    );
};

export default SlideButton;
